import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';
import { CloudFirmwareStatus } from '../../types';

type FirmwareUpdateBannerContentProps = {
  cloudFirmwareStatus: CloudFirmwareStatus;
};

export function FirmwareUpdateBannerContent({ cloudFirmwareStatus }: FirmwareUpdateBannerContentProps) {
  const { t } = useTranslation();
  const { h, fontSize } = useBannerSize();
  const firmwareBannerBody =
    cloudFirmwareStatus === 'Pending'
      ? t('EVSE.firmware banner pending body')
      : t('EVSE.firmware banner in progress body');

  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center" pr={2} borderRadius="md">
        <Text fontSize={fontSize} letterSpacing="wider" data-testid="firmware-update-banner-title">
          {t('EVSE.firmware banner title')}
        </Text>
        <Text fontSize="sm" data-testid="firmware-update-banner-body">
          {firmwareBannerBody}
        </Text>
      </Box>
    </Flex>
  );
}
